/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
/* eslint-env browser */
import classnames from 'classnames'
import React from 'react'

import slug from 'slug'
import { getCDNUrl } from '../../../../../../shared/services/media-helper'
import { getCorrectHydroBasePath } from '../../../../pages/map-hydro/utils'
import { useTranslator } from '../TranslatorProvider'
import { HydroCard } from './HydroCard'

interface HydroInfosProps {
  host: string
  hostPath: string
  locale: string
  initialQuery?: string
  description?: string
  fishingTrails?: {
    id: string
    name: string
    geometryPoint: {
      type: string
      coordinates: number[]
    }
  }[]
  waters?: {
    countryName: string
    deptName: string
    boundaryName: string
    boundaryOsmId: string
    name: string
    pageUrl: string
  }[]
  species?: {
    id: string
    name: string
    seoName: string
    medias: { url: string; url_300?: string; url_600?: string }[]
    sciGenus?: string
    sciSpecies?: string
    sciAdditional?: string
  }[]
  catchMethods: {
    id: string
    name: string
  }[]
  boundaries?: {
    countryName: string
    deptName: string
    boundaryName: string
    boundaryOsmId: string
    pageUrl: string
  }[]
  throughBoundaries?: {
    countryName: string
    deptName: string
    boundaryName: string
    boundaryOsmId: string
    pageUrl: string
  }[]
  businesses?: {
    id: string
    name: string
    seoName: string
  }[]
  titles?: {
    species?: string
    catchMethods?: string
    businesses?: string
    boundaries?: string
    throughBoundaries?: string
    waters?: string
    fishingTrails?: string
  }
  descriptions?: {
    species?: string
    catchMethods?: string
    businesses?: string
    boundaries?: string
    throughBoundaries?: string
    waters?: string
    fishingTrails?: string
  }
  counts: {
    species: number
    catchMethods: number
    businesses: number
    boundaries: number
    throughBoundaries?: number
    waters: number
    fishingTrails: number
  }
}

export const HydroInfos: React.FC<HydroInfosProps> = ({
  fishingTrails,
  waters,
  species,
  businesses,
  throughBoundaries,
  boundaries,
  catchMethods,
  titles,
  descriptions,
  counts,
  description,
  locale,
  host,
  hostPath,
}) => {
  const t = useTranslator(locale)

  return (
    <div>
      <div className="columns is-multiline has-padding-horizontal-small-mobile has-padding-horizontal-medium-tablet">
        {description && (
          <div className="column is-12">
            <p>{description}</p>
            {/*
            <p>
              <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
            </p>
            */}
          </div>
        )}
        {fishingTrails && fishingTrails.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.fishingTrails && <h2 className="title is-size-4">{titles.fishingTrails}</h2>}
              {descriptions && descriptions.fishingTrails && <p>{descriptions.fishingTrails}</p>}
            </div>
            <div className="column is-12">
              <div className="columns">
                {fishingTrails.slice(0, 3).map(elt => (
                  <HydroCard
                    key={`${elt.id}-${elt.name}`}
                    imgSrc={`/api/hydro/mapPin/${elt.geometryPoint.coordinates[1]}/${elt.geometryPoint.coordinates[0]}.png`}
                    imgAlt={elt.name}
                    title={`${elt.name}`}
                    href={`/spots/${slug(elt.name)}-${elt.id}`}
                    icon="fa-map-pin"
                    classes={{ 'is-3-desktop': false }}
                  />
                ))}
              </div>
            </div>
            <div className="column is-12 has-text-right">
              {counts && counts.fishingTrails && counts.fishingTrails > 3 && (
                <p className="has-margin-bottom-small">
                  <a href={`${hostPath.replace('infos', '')}fishingTrails`}>
                    <b>{`${t('hydro.infos.seeAll.fishingTrails', {
                      totalCount: counts.fishingTrails,
                    })} >`}</b>
                  </a>
                </p>
              )}
              {/*
              <p>
                <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
              </p>
              */}
            </div>
          </>
        )}
        {waters && waters.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.waters && <h2 className="title is-size-4">{titles.waters}</h2>}
              {descriptions && descriptions.waters && <p>{descriptions.waters}</p>}
            </div>
            <div className="column is-12">
              <div className="columns">
                {waters.map(elt => (
                  <HydroCard
                    key={`${elt.countryName}/${elt.deptName}/${elt.boundaryName}-${elt.boundaryOsmId}/${elt.name}`}
                    imgSrc={`/api/hydro/boundaries/${elt.boundaryOsmId}/${elt.name}/contour.png`}
                    imgAlt={`${elt.name} (${elt.boundaryName}, ${elt.deptName}, ${elt.countryName})`}
                    title={`${elt.name}, ${elt.boundaryName}`}
                    href={`/${getCorrectHydroBasePath(locale)}/${elt.countryName}/${elt.deptName}/${elt.boundaryName}-${
                      elt.boundaryOsmId
                    }/${elt.name}`}
                    icon="fa-water"
                    classes={{ 'is-3-desktop': false }}
                  />
                ))}
              </div>
            </div>
            <div className="column is-12 has-text-right">
              {counts && counts.waters && counts.waters > 3 && (
                <p className="has-margin-bottom-small">
                  <a href={`${hostPath.replace('infos', '')}waters`}>
                    <b>{`${t('hydro.infos.seeAll.waters', {
                      totalCount: counts.waters,
                    })} >`}</b>
                  </a>
                </p>
              )}
              {/*
              <p>
                <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
              </p>
              */}
            </div>
          </>
        )}
        {throughBoundaries && throughBoundaries.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.throughBoundaries && <h2 className="title is-size-4">{titles.throughBoundaries}</h2>}
              {descriptions && descriptions.throughBoundaries && <p>{descriptions.throughBoundaries}</p>}
            </div>
            <div className="column is-12">
              <div className="columns">
                {throughBoundaries.map(elt => (
                  <HydroCard
                    key={`${elt.countryName}/${elt.deptName}/${elt.boundaryName}-${elt.boundaryOsmId}`}
                    imgSrc={`/api/hydro/boundaries/${elt.boundaryOsmId}/contour.png`}
                    imgAlt={`${elt.boundaryName} (${elt.deptName} / ${elt.countryName})`}
                    title={elt.boundaryName}
                    href={`/${getCorrectHydroBasePath(locale)}/${elt.countryName}/${elt.deptName}/${elt.boundaryName}-${
                      elt.boundaryOsmId
                    }`}
                    icon="fa-map-pin"
                    classes={{ 'is-3-desktop': false }}
                  />
                ))}
              </div>
            </div>
            <div className="column is-12 has-text-right">
              {counts && counts.throughBoundaries && counts.throughBoundaries > 3 && (
                <p className="has-margin-bottom-small">
                  <a href={`${hostPath.replace('infos', '')}boundaries`}>
                    <b>{`${t('hydro.infos.seeAll.boundaries', {
                      totalCount: counts.throughBoundaries,
                    })} >`}</b>
                  </a>
                </p>
              )}
              {/*
              <p>
                <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
              </p>
              */}
            </div>
          </>
        )}
        {boundaries && boundaries.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.boundaries && <h2 className="title is-size-4">{titles.boundaries}</h2>}
              {descriptions && descriptions.boundaries && <p>{descriptions.boundaries}</p>}
            </div>
            <div className="column is-12">
              <div className="columns">
                {boundaries.map(elt => (
                  <HydroCard
                    key={`${elt.countryName}/${elt.deptName}/${elt.boundaryName}-${elt.boundaryOsmId}`}
                    imgSrc={`/api/hydro/boundaries/${elt.boundaryOsmId}/contour.png`}
                    imgAlt={`${elt.boundaryName} (${elt.deptName} / ${elt.countryName})`}
                    title={elt.boundaryName}
                    href={`/${getCorrectHydroBasePath(locale)}/${elt.countryName}/${elt.deptName}/${elt.boundaryName}-${
                      elt.boundaryOsmId
                    }`}
                    icon="fa-map-pin"
                    classes={{ 'is-3-desktop': false }}
                  />
                ))}
              </div>
            </div>
            <div className="column is-12 has-text-right">
              {counts && counts.boundaries && counts.boundaries > 3 && (
                <p className="has-margin-bottom-small">
                  <a href={`${hostPath.replace('infos', '')}boundaries`}>
                    <b>{`${t('hydro.infos.seeAll.boundaries', {
                      totalCount: counts.boundaries,
                    })} >`}</b>
                  </a>
                </p>
              )}
              {/*
              <p>
                <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
              </p>
              */}
            </div>
          </>
        )}
        {species && species.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.species && <h2 className="title is-size-4">{titles.species}</h2>}
              {descriptions && descriptions.species && <p>{descriptions.species}</p>}
            </div>
            <div className="column is-12">
              <div className="columns">
                {species.map(oneSpecies => (
                  <div key={oneSpecies.id} className={classnames('column is-12-mobile is-4-tablet')}>
                    <a href={`/fish/${oneSpecies.seoName}`}>
                      <div className="card">
                        {oneSpecies.medias && oneSpecies.medias.length > 0 && (
                          <div className="card-image">
                            <figure className="image is-2by1">
                              <img
                                className="has-object-fit-contain"
                                src={getCDNUrl(oneSpecies.medias[0], 'small', {
                                  name: oneSpecies.seoName,
                                  type: 'fishSpecies',
                                })}
                                alt={oneSpecies.name}
                              />
                            </figure>
                          </div>
                        )}
                        <div className="card-content icon-text">
                          <p className="title is-6">
                            <span className="icon has-text-info">
                              <i className="far fa-fish" />
                            </span>
                            <span>{oneSpecies.name}</span>
                          </p>
                          <p className="subtitle is-7">
                            <span>
                              <i>
                                {[oneSpecies.sciGenus, oneSpecies.sciSpecies, oneSpecies.sciAdditional]
                                  .filter(elt => !!elt && elt.length > 0)
                                  .join(' ')}
                              </i>
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="column is-12 has-text-right">
              {counts && counts.species && counts.species > 3 && (
                <p className="has-margin-bottom-small">
                  <a href={`${hostPath.replace('infos', '')}species`}>
                    <b>{`${t('hydro.infos.seeAll.species', {
                      totalCount: counts.species,
                    })} >`}</b>
                  </a>
                </p>
              )}
              {/*
              <p>
                <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
              </p>
              */}
            </div>
          </>
        )}
        {catchMethods && catchMethods.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.catchMethods && <h2 className="title is-size-4">{titles.catchMethods}</h2>}
              {descriptions && descriptions.catchMethods && <p>{descriptions.catchMethods}</p>}
            </div>
            <div className="column is-12">
              <ul>
                {catchMethods.map(catchMethod => (
                  <li key={catchMethod.id}>{catchMethod.name}</li>
                ))}
              </ul>
            </div>
          </>
        )}
        {businesses && businesses.length > 0 && (
          <>
            <div className="column is-12">
              <hr />
              {titles && titles.businesses && <h2 className="title is-size-4">{titles.businesses}</h2>}
              {descriptions && descriptions.businesses && <p>{descriptions.businesses}</p>}
            </div>
            <div className="column is-12">
              <ul>
                {businesses.map(business => (
                  <div key={business.id} className="media">
                    <div className="media-content is-self-centered">
                      <a
                        href={`/businesses/${business.id}/${business.seoName}`}
                        className="has-text-weight-bold has-text-break-word"
                      >
                        {business.name}
                      </a>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
            <div className="column is-12 has-text-right">
              {/*
              <p>
                <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
              </p>
              */}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
